var map = {
	"./bracelet/beautiful-bracelet_720x480.jpg": 78,
	"./bracelet/couple-bracelet_720x480.jpg": 79,
	"./bracelet/cross-bracelet_720x480.jpg": 80,
	"./bracelet/silver-band_720x480.jpg": 81,
	"./earing/acrylic-earing_720x480.jpg": 82,
	"./earing/modern-earing_720x480.jpg": 83,
	"./earing/streamlined-earing_720x480.jpg": 84,
	"./earing/tassel-earing_720x480.jpg": 85,
	"./earing/victorian-earing_720x480.jpg": 86,
	"./necklace/crystal-pendent_720x480.jpg": 87,
	"./necklace/elegant-pendent_720x480.jpg": 88,
	"./necklace/handmade-necklace_720x480.jpg": 89,
	"./necklace/heart-shaped-pendent_720x480.jpg": 90,
	"./necklace/pigeon-pendent_720x480.jpg": 91,
	"./ring/couple-rings_720x480.jpg": 92,
	"./ring/dolphin-ring_720x480.jpg": 93,
	"./ring/golden-ring_720x480.jpg": 94,
	"./ring/ring-band_720x480.jpg": 95,
	"./ring/sea-turtle-ring_720x480.jpg": 96,
	"./ring/stack-ring_720x480.jpg": 97
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;